import { Button } from 'antd'
import { connect } from 'react-redux'
import { toggleSearchModal } from 'Actions/explore'
import Feather from '@sysunite/react-feather'

Search = ({ searchModalVisible, toggleSearchModal }) ->

  toggleSearch = ->
    toggleSearchModal(not searchModalVisible)

  <Button
    data-testid="global-search-button"
    onClick={toggleSearch}
    style={{
      marginRight: '10px'
      paddingRight: '6px'
      color: '#646464'
    }}
    type="link"
    icon={<Feather size="1em" type="search"/>}
  />

mapStateToProps = ({ explore: { searchModalVisible }}) ->
  { searchModalVisible }

export default connect(mapStateToProps, { toggleSearchModal })(Search)
